var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card h-100"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.$t('news.news-analysis'))+" ")]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-4"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"card-title d-flex align-items-center justify-content-between"},[_c('h5',[_vm._v(_vm._s(_vm.$t('news.statistics')))]),_c('div',{staticClass:"d-flex"},[(_vm.showBy == 'date')?_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"text-right mr-2 my-auto",staticStyle:{"width":"80px"}},[_vm._v(_vm._s(_vm.$t('news.filter')))]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateFilter),expression:"dateFilter"}],staticClass:"custom-select custom-select-sm mr-2",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dateFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeFilter]}},[_c('option',[_vm._v(_vm._s(_vm.$t('news.all')))]),_c('option',[_vm._v(_vm._s(_vm.$t('news.last-7-day')))]),_c('option',[_vm._v(_vm._s(_vm.$t('news.this-month')))]),_c('option',[_vm._v(_vm._s(_vm.$t('news.this-year')))])])]):_vm._e(),(_vm.showBy == 'source')?_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"text-right mr-2 my-auto",staticStyle:{"width":"140px"}},[_vm._v(_vm._s(_vm.$t('news.media-type')))]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sourceFilter),expression:"sourceFilter"}],staticClass:"custom-select custom-select-sm mr-2",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sourceFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changeFilter]}},[_c('option',[_vm._v(_vm._s(_vm.$t('news.all')))]),_c('option',[_vm._v("Mainstream")]),_c('option',[_vm._v("Non Mainstream")]),_c('option',[_vm._v("Unknown")])])]):_vm._e(),_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"text-right mr-2 my-auto",staticStyle:{"width":"80px"}},[_vm._v(_vm._s(_vm.$t('news.show-by')))]),_c('b-dropdown',{attrs:{"right":"","variant":"secondary","size":"sm"}},[_c('template',{slot:"button-content"},[_vm._v(" "+_vm._s(_vm.showBy == _vm.$t('news.source') ? _vm.$t('news.source') : _vm.$t('news.publish-date'))+" "),_c('i',{staticClass:"mdi mdi-chevron-down"})]),_c('b-dropdown-item',{class:_vm.showBy == 'source' ? 'bg-light': '',on:{"click":function($event){return _vm.changeShow('source')}}},[_vm._v(_vm._s(_vm.$t('news.source')))]),_c('b-dropdown-item',{class:_vm.showBy == 'date' ? 'bg-light': '',on:{"click":function($event){return _vm.changeShow('date')}}},[_vm._v(_vm._s(_vm.$t('news.publish-date')))])],2)],1)])]),_c('hr')]),(!_vm.nodata.statsentiment)?_c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"350","type":"bar","dir":"ltr","series":_vm.seriesSentimentFilter,"options":{
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            },
                            plotOptions: {
                                bar: {
                                    horizontal: false,
                                    columnWidth: '100%',
                                    endingShape: 'rounded'
                                },
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                show: true,
                                width: 2,
                                colors: ['transparent']
                            },
                            colors: ['#34c38f', '#38BDF8', '#f46a6a'],
                            xaxis: {
                                categories: _vm.categoriesSentimentFilter,
                            },
                            yaxis: {
                                title: {
                                    text: '% (sentiment)'
                                },
                                axisBorder: {
                                    show: true,
                                    color: '#78909C',
                                    offsetX: 0,
                                    offsetY: 0
                                },
                                max: 100,
                            },
                            grid: {
                                row: {
                                    colors: ['#f1f1f1', 'transparent'],
                                    opacity: 0.2
                                },
                                borderColor: '#f1f1f1',
                            },
                            fill: {
                                opacity: 1
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val) {
                                        return val + '%'
                                    }
                                }
                            },
                            noData: {
                                text: _vm.noDataMessage.sentiment,
                                style: {
                                    fontSize: '14px',
                                }
                            }
                        }}})],1):_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"margin-top":"5%","margin-bottom":"5%"}},[_c('i',{staticClass:"bx bxs-bar-chart-alt-2 bx-lg"}),_c('span',[_vm._v(_vm._s(_vm.$t('all.dnf')))])])]),_c('div',{staticClass:"col-12 mb-4"},[_c('div',{staticClass:"clearfix"},[_c('h5',{staticClass:"card-title mb-4"},[_vm._v(_vm._s(_vm.$t('news.statistic-news')))]),_c('hr')]),(!_vm.nodata.statnews)?_c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"380","type":"area","dir":"ltr","series":[{name: 'News', data: _vm.seriesData}],"options":{
                            chart: {
                                zoom: {
                                    enabled: false
                                },
                                toolbar: {
                                    show: false
                                }
                            },
                            colors: ['#556ee6'],
                            dataLabels: {
                                enabled: false,
                            },
                            stroke: {
                                width: 3,
                                curve: 'smooth',
                            },
                            grid: {
                                row: {
                                    colors: ['#f1f1f1', 'transparent'],
                                    opacity: 0.2
                                },
                                borderColor: '#f2f2f2'
                            },
                            markers: {
                                style: 'inverted',
                                size: 0,
                            },
                            xaxis: {
                                categories: _vm.optionCategories,
                                title: {
                                    text: _vm.$t('news.publish-date'),
                                    style: {
                                        color: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '12px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 600,
                                        cssClass: 'apexcharts-xaxis-title',
                                    },
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        colors: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '10px',
                                    },
                                },
                            },
                            yaxis: {
                                title: {
                                    text: _vm.$t('news.total-news'),
                                    style: {
                                        color: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '12px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 600,
                                        cssClass: 'apexcharts-xaxis-title',
                                    },
                                },
                                labels: {
                                    show: true,
                                    style: {
                                        colors: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                        fontSize: '10px',
                                    },
                                },
                                min: 0,
                                max: _vm.ymax
                            },
                            legend: {
                                position: 'top',
                                horizontalAlign: 'right',
                                floating: true,
                                offsetY: -25,
                                offsetX: -5
                            },
                            responsive: [{
                                breakpoint: 600,
                                options: {
                                    chart: {
                                        toolbar: {
                                            show: false
                                        }
                                    },
                                    legend: {
                                        show: false
                                    },
                                }
                            }],
                            noData: {
                                text: _vm.noDataMessage.news,
                                style: {
                                    fontSize: '14px',
                                }
                            }
                        }}})],1):_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"margin-top":"5%","margin-bottom":"5%"}},[_c('i',{staticClass:"bx bxs-bar-chart-alt-2 bx-lg"}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('all.dnf')))])])]),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"clearfix"},[_c('h5',{staticClass:"card-title mb-4"},[_vm._v(" "+_vm._s(_vm.$t('news.source')))]),_c('hr')]),(!_vm.loading.source)?_c('div',[(!_vm.nodata.source)?_c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"400","type":"donut","dir":"ltr","series":_vm.seriesSource,"options":{
                                plotOptions: {
                                    pie: {
                                            donut: {
                                            labels: {
                                                show: true,
                                                name: {
                                                    show: true,
                                                    fontSize: '22px',
                                                    fontFamily: 'Rubik',
                                                    color: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                                },
                                                value: {
                                                    show: true,
                                                    fontSize: '16px',
                                                    fontFamily: 'Helvetica, Arial, sans-serif',
                                                    color: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                                },
                                                total: {
                                                    show: true,
                                                    label: 'Total',
                                                    color: _vm.theme == 'dark'? '#F8F8FB' : '#343a40'
                                                }
                                            }
                                        }
                                    },
                                },
                                labels: _vm.labelsSource,
                                colors: _vm.colorsSource,
                                legend: {
                                    show: true,
                                    position: 'bottom',
                                    horizontalAlign: 'center',
                                    verticalAlign: 'middle',
                                    floating: false,
                                    fontSize: '14px',
                                    offsetX: 0,
                                    offsetY: -10,
                                    labels: {
                                        colors: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                    }
                                },
                                responsive: [{
                                    breakpoint: 600,
                                    options: {
                                        chart: {
                                            height: 240
                                        },
                                        legend: {
                                            show: false
                                        },
                                    }
                                }]
                            }}})],1):_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"margin-top":"15%","margin-bottom":"15%"}},[_c('i',{staticClass:"bx bxs-doughnut-chart bx-lg"}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('all.dnf')))])])]):_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"margin-top":"15%","margin-bottom":"15%"}},[_c('i',{staticClass:"bx bx-loader-alt bx-lg bx-spin"})])]),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"clearfix"},[_c('h5',{staticClass:"card-title mb-4"},[_vm._v(" "+_vm._s(_vm.$t('news.sentiment')))]),_c('hr')]),(!_vm.loading.allsentiment)?_c('div',[(!_vm.nodata.allsentiment)?_c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"400","type":"pie","dir":"ltr","series":_vm.seriesSentiment,"options":{
                                    labels: _vm.labelsSentiment,
                                    colors: _vm.colorsSentiment,
                                    legend: {
                                        show: true,
                                        position: 'bottom',
                                        horizontalAlign: 'center',
                                        verticalAlign: 'middle',
                                        floating: false,
                                        fontSize: '14px',
                                        offsetX: 0,
                                        offsetY: -10,
                                        labels: {
                                            colors: _vm.theme == 'dark'? '#F8F8FB' : '#343a40',
                                        }
                                    },
                                    responsive: [{
                                        breakpoint: 600,
                                        options: {
                                            chart: {
                                                height: 500
                                            },
                                            legend: {
                                                show: false
                                            },
                                        }
                                    }]
                                }}})],1):_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"margin-top":"15%","margin-bottom":"15%"}},[_c('i',{staticClass:"bx bxs-pie-chart-alt-2 bx-lg"}),_c('span',[_vm._v(_vm._s(_vm.$t('all.dnf')))])])]):_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",staticStyle:{"margin-top":"15%","margin-bottom":"15%"}},[_c('i',{staticClass:"bx bx-loader-alt bx-lg bx-spin"})])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }